/**
 * In-memory access token store. AUTH-05 — NEVER localStorage / sessionStorage / cookies.
 *
 * Rationale: XSS payloads read client-side storage; the access token stays in
 * module-local memory and disappears on hard refresh. The HttpOnly refresh
 * cookie reconstitutes the session on boot via the session-sentinel + silent
 * refresh path (Plan 04).
 *
 * Shape: `{ token, exp, issuedAt }` are stored together so Plan 04's refresh
 * timer can schedule ahead of `exp - REFRESH_SKEW_SECONDS` without a second
 * decode pass.
 */
interface TokenRecord {
  token: string;
  /** seconds since epoch */
  exp: number;
  /** seconds since epoch */
  issuedAt: number;
}

let record: TokenRecord | null = null;

export const accessTokenStore = {
  set(token: string, exp: number, issuedAt: number): void {
    record = { token, exp, issuedAt };
  },
  get(): string | null {
    return record?.token ?? null;
  },
  getRecord(): TokenRecord | null {
    return record;
  },
  clear(): void {
    record = null;
  },
};
